<template>
  <component :is="component" :boardData="boardData" :paginationData="paginationData" v-if="component" :boardType="boardType"/>
</template>

<script>
export default {
  name: "BoardListLink",
  mixins: [],
  components: {},
  provide() {
    return {}
  },
  props: {
    listLayout: {},
    boardData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
    boardType:'',

  },
  data() {
    return {
      component: null,
    }
  },
  created() {
  },
  mounted() {
    this.listLoader();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/board/list/${this.listLayout}`)
    },
  },
  methods: {
    listLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/board/list/BoardListDefaultLayout')
          })
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>